import { useMemo } from 'react';
import * as yup from 'yup';
import { useGoalFormState } from '../GoalSidebar/goalFormState';

export type UpdateKeyResultFormData = {
  currentValue: number;
  comments: string | null;
};

const validationSchema: yup.ObjectSchema<UpdateKeyResultFormData> = yup.object({
  comments: yup.string().max(32768).ensure().trim(),
  currentValue: yup.number().required(),
});

type Props = {
  comments: string | null;
  currentValue: number;
};

const commentsField = 'comments';
const currentValueField = 'currentValue';

export const useUpdateKeyResultForm = ({ comments, currentValue }: Props) => {
  const defaultValues: UpdateKeyResultFormData = {
    comments: comments ?? '',
    currentValue: currentValue ?? ('' as unknown as number),
  };
  const form = useGoalFormState<UpdateKeyResultFormData>(
    defaultValues,
    validationSchema,
  );

  return useMemo(
    () => ({
      form,
      commentsField,
      currentValueField,
    }),
    [form],
  );
};
